import type { z } from "zod";

import type { createValidationSchema } from "@/features/trips/utils/validation";
import type {
  FindPackageByIdData,
  FindPackagesPackage,
  FindUserPackageBookingByIdPackageBooking,
} from "@/types/codegen";
import type { SortValue } from "@/types/types";

export type Trip = FindPackagesPackage;

export type TripDetails = FindPackageByIdData;

export type TripBooking = FindUserPackageBookingByIdPackageBooking;

export type BookingData = z.infer<ReturnType<typeof createValidationSchema>>;
export type SelectedTravellers = BookingData["travellers"];
export type TravellerType = keyof SelectedTravellers;

export enum TripsSortOptions {
  PRICE = "price",
  DURATION = "durationInDays",
  NAME = "name",
  CREATED_AT = "createdAt",
  POSITION = "position",
}

export type TripsSortValue = SortValue<TripsSortOptions>;
